<div class="automl-login__outer">
<form class="automl-login__box" [formGroup]="loginForm">
    <div class="automl-login__head">Enter Login details</div>
    <div class="scad-input">
        <div class="scad-input__label">User Name</div>
        <input type="text" formControlName="username" placeholder="Enter Username" [ngClass]="{'error':loginForm.controls['username'].errors && loginForm.controls['username'].touched}">
    </div>
    <div class="scad-input">
        <div class="scad-input__label">Password</div>
        <input type="password" formControlName="password" placeholder="Enter Password" [ngClass]="{'error':loginForm.controls['password'].errors && loginForm.controls['password'].touched}">
    </div>
    <a (click)="login()" class="scad-btn scad-btn--primary">
        Login
        <app-circle-loader *ngIf="isLoading" color="white"></app-circle-loader>
    </a>
</form>
</div>